<script lang="ts" setup>
import { formatValue } from '@forgd/formatter'
import { KpiStat } from '@forgd/ui-kit/blocks/kpi-stat'
import { PencilIcon } from '@heroicons/vue/24/outline'
import { differenceInDays } from 'date-fns'

const props = defineProps<{
  loading?: boolean
  projectId: string
  tgeDate?: string | null
  isResearch?: boolean
}>()

const daysUntilTge = computed(() => (props.tgeDate ? differenceInDays(props.tgeDate, new Date()) : undefined))

function goToTokenSettings() {
  navigateTo(`/project/${props.projectId}/token-settings`)
}
</script>

<template>
  <KpiStat
    size="sm"
    :loading="loading"
    title="Est. TGE Date"
    :value="tgeDate ? formatValue(tgeDate, 'date') : 'Configure date'"
    :description="tgeDate ? 'Is the project listed? Update' : 'Recommended'"
    :action="{ icon: PencilIcon, label: 'Edit' }"
    @action="goToTokenSettings"
  >
    <template v-if="daysUntilTge != null && daysUntilTge < 0" #description>
      <span v-if="isResearch" class="text-secondary">This is a demo TGE</span>
      <span v-else class="text-error">Your TGE date needs attention</span>
    </template>
  </KpiStat>
</template>
